import AdFormService from "./services/AdFormService";
import {Section} from "./services/Section";
import PageData from "./PageData";


export default class InternalStatsTracker {
    private adFormService: AdFormService;

    constructor() {
        this.adFormService = new AdFormService()
    }

    public trackApplyImpressions(pageData: PageData, elements: HTMLElement[]) {
        if (!(elements && elements.length > 0)) {
            return;
        }
        elements.forEach(element => {
            const trackData = element.dataset.track;
            if (!trackData) {
                return;
            }
            const trackDataJson = JSON.parse(trackData);
            const section = trackDataJson.section;
            const step = trackDataJson.step;
            const isProject = trackDataJson.isProject;
            if (!(section && step && isProject)) {
                return;
            }
            console.debug("trackApplyImpressions", pageData.pageViewId, pageData.id, section, step, isProject);
            this.adFormService.sendApplyImpression({
                pageViewId: pageData.pageViewId,
                propertyAdId: pageData.id,
                section: section as Section,
                step: parseInt(step),
                isProject: isProject === "true",
            });
        });
    }
}
